import { useEffect, useMemo, useState } from "react";
import VehicleCard from "@/components/site/VehicleCard";
import { RevealOnScroll } from "@/components/site/Reveal";
import CantFindItCTA from "@/components/site/CantFindItCTA";
import { api } from "@/lib/api";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "ev", label: "Electric" },
  { key: "hybrid", label: "Hybrid" },
  { key: "petrol", label: "Petrol" },
];

export default function Inventory() {
  const [vehicles, setVehicles] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/vehicles").then((r) => setVehicles(r.data)).catch(() => {}); }, []);
  const list = useMemo(() => filter === "all" ? vehicles : vehicles.filter((v) => v.type === filter), [vehicles, filter]);

  return (
    <div data-testid="inventory-page" className="pt-40 pb-24 md:pb-32 bg-ink">
      <div className="container-editorial">
        <div className="mb-20 md:mb-24">
          <span className="block h-px bg-[#C5A059] w-14 mb-8" />
          <div className="overline text-[#C5A059] mb-6">The Inventory</div>
          <RevealOnScroll
            element="h1"
            className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
            lines={["Every car,", "<em>considered</em>."]}
          />
          <p className="editorial-body mt-10 max-w-2xl">
            A curated selection of recent and reference sourcings. Every vehicle
            on Maklan Motors is procured to specification through our
            international supplier network — not held in a lot. If you don't see
            it, we can still find it.
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-16" data-testid="inventory-filters">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`filter-${f.key}`}
              className={`px-6 py-3 text-[11px] tracking-[0.28em] uppercase border transition-colors duration-700 ${
                filter === f.key
                  ? "bg-[#C5A059] text-[#050814] border-[#C5A059]"
                  : "border-white/15 text-white/70 hover:border-[#C5A059]/60 hover:text-white"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <div className="text-white/60 py-24 text-center border border-white/10">
            No vehicles in this category yet. Please check back soon.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-20 md:gap-y-24">
            {list.map((v, i) => <VehicleCard key={v.id} vehicle={v} index={i} />)}
          </div>
        )}
      </div>
      <CantFindItCTA />
    </div>
  );
}
